export function buildLink(statusEntry) {
  if (statusEntry.type === 'ContentfulConfig') {
    // This is a contentful entry
    return `https://app.contentful.com/spaces/${statusEntry.entry.sys.space.sys.id}/environments/${statusEntry.entry.sys.environment.sys.id}/entries/${statusEntry.entry.sys.id}`
  } else {
    // This is wordpress
    return statusEntry.data.link
  }
}
